import { Descriptions } from "antd";
import { DescriptionsProps as Props } from "antd/lib/descriptions";
import { DescriptionsItemProps as ItemProps } from "antd/lib/descriptions/Item";
import React from "react";

export const Component: Component<{
  readonly Title?: string | Component;
  readonly Extra?: Props["extra"];
  readonly bordered?: Props["bordered"];
  readonly column?: Props["column"];
  readonly children?: Props["children"];
  readonly layout?: Props["layout"];
  readonly style?: Props["style"];
}> = ({ Title, Extra, children, ...props }) => (
  <Descriptions
    prefixCls="es-descriptions"
    title={Title}
    extra={Extra}
    {...props}
  >
    {children}
  </Descriptions>
);

export namespace Item {
  export const Component: Component<{
    readonly label?: ItemProps["label"];
    readonly children?: ItemProps["children"];
    readonly style?: ItemProps["style"];
  }> = ({ children, ...props }) => (
    <Descriptions.Item {...props}>{children}</Descriptions.Item>
  );
}
